<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><g><path d="M-1277 22098.006h-12a1.006 1.006 0 0 1-1-1v-14a1.006 1.006 0 0 1 1-1h8v4a1 1 0 0 0 1 1h4v10a1 1 0 0 1-1 1zm-8.5-8.5v1h2v2h1v-2h2v-1h-2v-2h-1v2z" style="fill:#517dfb" transform="translate(1292.999 -22080.002)" fill="currentColor"/><g clip-path="path(M-1575 22157h-14v-16h10.005l4 4.006v12z)"><path d="M0 0h4v4H0z" style="fill:#517dfb" transform="translate(-588 -344) translate(601 346)" fill="currentColor"/></g></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-widget-new',
});
</script>
